import { type OrderDraftItemFieldErrors } from '../types/OrderDraftItemFieldErrors'

export class OrderDraftItemValidationError extends Error {
  constructor(public readonly fieldErrors: OrderDraftItemFieldErrors) {
    super('Order draft item field errors')
    this.name = 'OrderDraftItemValidationError'
  }
}
